import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import Tooltip from "@material-ui/core/Tooltip";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import AuthService from "../auth/AuthService";
import UpdateIcon from "@material-ui/icons/Update";
import Message from "../common/Message";

export default class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_id: props.user_id,
      first_name: props.first_name,
      last_name: props.last_name,
      email: props.email,
      password: props.password,
      role: props.role,
      cnic: props.cnic,
      contact: props.contact,
      address: props.address,
      gender: props.gender,
      dob: props.dob,
      education: props.education,
      experience: props.experience,
      training: props.training,
      belongs_to_community: props.belongs_to_community,
      attendence: props.attendence,
      open: false,
      errorMessage: "",
      first_nameErrorMessage: "",
      last_nameErrorMessage: "",
      cnicErrorMessage: "",
      contactErrorMessage: "",
      addressErrorMessage: "",
      dobErrorMessage: "",
      serverError: "",
      emailErrorMessage: "",
    };
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.Auth = new AuthService();
  }
  // const[open, setOpen] = React.useState (false);

  handleClickOpen() {
    this.setState({ open: true });
  }

  resetForm() {
    this.setState({
      email: "",
      first_name: "",
      password: "",
      role: 1,
      gender: "1",
      open: false,
      errorMessage: "",
      first_nameErrorMessage: "",
      last_nameErrorMessage: "",
      emailErrorMessage: "",
      passwordErrorMessage: "",
      cnicErrorMessage: "",
      contactErrorMessage: "",
      addressErrorMessage: "",
      dobErrorMessage: "",
      serverError: "",
    });
  }

  handleSubmit(event) {
    this.setState(
      {
        first_nameErrorMessage:
          this.state.first_name === "" ? "Frist Name is required " : "",
        last_nameErrorMessage:
          this.state.last_name === "" ? "Last Name is required " : "",
        emailErrorMessage:
          /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            this.state.email
          )
            ? ""
            : "Invalid email address",
        cnicErrorMessage: this.state.cnic === "" ? "CNIC ID is required" : "",
        contactErrorMessage:
          this.state.contact === "" ? "Contact is required" : "",
        addressErrorMessage:
          this.state.address === "" ? "Address is required" : "",
        dobErrorMessage: this.state.dob === "" ? "DOB is required" : "",
      },
      () => {
        if (
          this.state.first_nameErrorMessage.length > 0 ||
          this.state.last_nameErrorMessage.length > 0 ||
          this.state.emailErrorMessage.length > 0 ||
          this.state.cnicErrorMessage.length > 0 ||
          this.state.contactErrorMessage.length > 0 ||
          this.state.addressErrorMessage.length > 0 ||
          this.state.dobErrorMessage.length > 0
        ) {
          // this.setState({
          //   serverError: "Invalid data provided",
          // });
          console.log("Invalid data provided");
        } else {
          this.Auth.post("crud", {
            id_key: "user_id",
            id_value: this.state.user_id,
            table: "users",
            action: "update",
            email: this.state.email,
            password: this.state.password,
            role: this.state.role,
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            cnic: this.state.cnic,
            contact: this.state.contact,
            address: this.state.address,
            gender: this.state.gender,
            status: this.state.status,
            dob: this.state.dob,
            education: this.state.education,
            experience: this.state.experience,
            training: this.state.training,
            belongs_to_community: this.state.belongs_to_community,
            attendence: this.state.attendence,
          })
            .then((data) => {
              console.log(data);
              if (data.error) {
                this.setState({ serverError: data.message });
              } else {
                this.setState({
                  errorMessage: "",
                  email: "",
                  first_name: "",
                  password: "",
                  open: false,
                  cnic: "",
                  contact: "",
                  address: "",
                  gender: "1",
                  dob: "",
                });
                // this.props.propAddLink(data.user);
                window.location.reload();
              }
            })
            .catch((err) => {
              console.log("err", err);
              this.setState({
                errorMessage: "some error occurred please try again",
              });
            });
        }
      }
    );
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  }

  render() {
    const { plus } = this.props;
    return (
      <div style={{ float: "right" }}>
        {plus ? (
          <Tooltip title="Edit">
            <UpdateIcon
              style={{ cursor: "pointer" }}
              variant="outlined"
              onClick={this.handleClickOpen}
            />
          </Tooltip>
        ) : (
          <Button
            variant="outlined"
            color="primary"
            onClick={this.handleClickOpen}
          >
            Open form dialog
          </Button>
        )}
        <br style={{ clear: "both" }} />

        <form onSubmit={this.handleSubmit}>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Update User</DialogTitle>
            {/* {this.state.serverError === "" ? (
              ""
            ) : (
                <div className="alert alert-danger" role="alert">
                  {this.state.serverError}
                </div>
              )} */}
            <Message msg={this.state.serverError} type="error" />
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                id="first_name"
                name="first_name"
                label="First Name"
                type="text"
                value={this.state.first_name || ""}
                fullWidth
                onChange={this.handleChange}
                error={this.state.first_nameErrorMessage === "" ? false : true}
                helperText={this.state.first_nameErrorMessage}
              />
              <TextField
                margin="dense"
                id="last_name"
                name="last_name"
                label="Last Name"
                type="text"
                value={this.state.last_name || ""}
                fullWidth
                onChange={this.handleChange}
                error={this.state.last_nameErrorMessage === "" ? false : true}
                helperText={this.state.last_nameErrorMessage}
              />
              <TextField
                margin="dense"
                id="email"
                name="email"
                label="Email"
                type="text"
                disabled
                value={this.state.email || ""}
                fullWidth
                onChange={this.handleChange}
                error={this.state.emailErrorMessage === "" ? false : true}
                helperText={this.state.emailErrorMessage}
              />

              <TextField
                margin="dense"
                id="password"
                name="password"
                label="Password"
                type="password"
                value={this.state.password || ""}
                fullWidth
                onChange={this.handleChange}
              />

              <TextField
                margin="dense"
                id="cnic"
                name="cnic"
                label="CNIC"
                type="text"
                value={this.state.cnic || ""}
                fullWidth
                onChange={this.handleChange}
                error={this.state.cnicErrorMessage === "" ? false : true}
                helperText={this.state.cnicErrorMessage}
              />
              <TextField
                margin="dense"
                id="contact"
                name="contact"
                label="Contact"
                type="text"
                value={this.state.contact || ""}
                fullWidth
                onChange={this.handleChange}
                error={this.state.contactErrorMessage === "" ? false : true}
                helperText={this.state.contactErrorMessage}
              />
              <TextField
                margin="dense"
                id="address"
                name="address"
                label="Address"
                type="text"
                value={this.state.address || ""}
                fullWidth
                onChange={this.handleChange}
                error={this.state.addressErrorMessage === "" ? false : true}
                helperText={this.state.addressErrorMessage}
              />
              <TextField
                margin="dense"
                id="dob"
                name="dob"
                label="DOB"
                type="date"
                value={this.state.dob || ""}
                fullWidth
                onChange={this.handleChange}
                error={this.state.dobErrorMessage === "" ? false : true}
                helperText={this.state.dobErrorMessage}
              />

              <TextField
                margin="dense"
                id="education"
                name="education"
                label="Education"
                type="text"
                value={this.state.education || ""}
                fullWidth
                onChange={this.handleChange}
              />
              <TextField
                margin="dense"
                id="experience"
                name="experience"
                label="Experience"
                type="text"
                value={this.state.experience || ""}
                fullWidth
                onChange={this.handleChange}
              />
              <TextField
                margin="dense"
                id="attendence"
                name="attendence"
                label="Attendence"
                type="text"
                value={this.state.attendence || ""}
                fullWidth
                onChange={this.handleChange}
              />
              <TextField
              style={{width:"100%"}}
                id="training"
                name="training"
                label="Training"
                select
                value={this.state.training}
                onChange={this.handleChange}
                SelectProps={{
                  native: true,
                }}
              >
                <option key="1" value="1">
                  Yes
                </option>
                <option key="0" value="0">
                  No
                </option>
              </TextField>
              <br />
              <TextField
              
                id="belongs_to_community"
                name="belongs_to_community"
                label="Belongs to community"
                select
                value={this.state.belongs_to_community}
                style={{ width: "100%" }}
                onChange={this.handleChange}
                SelectProps={{
                  native: true,
                }}
              >
                <option key="1" value="1">
                  Yes
                </option>
                <option key="0" value="0">
                  No
                </option>
              </TextField>
              <br />
              <TextField
              style={{width:"100%"}}
                id="gender"
                name="gender"
                label="Gender"
                select
                value={this.state.gender}
                onChange={this.handleChange}
                SelectProps={{
                  native: true,
                }}
                // helperText={this.state.errorMessage}
                // error={this.state.errorMessage === "" ? false : true}
              >
                <option key="Male" value="1">
                  Male
                </option>
                <option key="Female" value="1">
                  Female
                </option>
              </TextField>
              <br />
              <TextField
              style={{width:"100%"}}
                id="role"
                name="role"
                label="Role"
                select
                value={this.state.role}
                onChange={this.handleChange}
                SelectProps={{
                  native: true,
                }}
                // helperText={this.state.errorMessage}
                // error={this.state.errorMessage === "" ? false : true}
              >
                <option key="Admin" value="1">
                  Admin
                </option>
                <option key="Teacher" value="2">
                  Teacher
                </option>
              </TextField>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  this.setState({ errorMessage: "", open: false });
                  this.resetForm();
                }}
                color="primary"
              >
                Cancel
              </Button>
              <Button onClick={this.handleSubmit} color="primary">
                Update
              </Button>
            </DialogActions>
          </Dialog>
        </form>
      </div>
    );
  }
}
